import {bgs} from './colors';
import {manazeV6Colors} from './manazeV6Colors';

const {primary_3} = manazeV6Colors;
const {progressIndicatorColor} = bgs;

const progressIndicatorStyle = {
  containerStyle: {
    height: 3,
    backgroundColor: 'transparent',
    overflow: 'hidden',
    left: 0,
    right: 0,
    position: 'absolute',
    zIndex: 1,
  },
  animationStyle: {
    backgroundColor: progressIndicatorColor,
    width: 100,
    height: 3,
    animationName: 'horizontalStatusBar',
    animationDuration: '2s',
    animationIterationCount: 'infinite',
    animationTimingFunction: 'ease-out',
  },
};
const activityIndicatorStyle = {
  color: primary_3,
};
export {progressIndicatorStyle, activityIndicatorStyle};
